import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@numistic/ui'
import type { ReactNode } from 'react'

/** Узкая карточка для экранов входа, регистрации и сброса пароля. */
export function AuthCard({
  title,
  description,
  children,
}: {
  title: string
  description?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="mx-auto w-full max-w-sm py-6">
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          {description ? <CardDescription>{description}</CardDescription> : null}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  )
}
